import { ReactElement } from "react";
import { Card, CardProps } from "react-bootstrap";
import { CardHeaderProps } from "react-bootstrap/esm/CardHeader";
export interface ISimpleCard {
    cardProps?: CardProps;
    headerProps?: CardHeaderProps;
    header?: string;
    title?: string;
    text?: string;
    children?: ReactElement;
}
const SimpleCard = (props: ISimpleCard) => {
    const { cardProps, header, headerProps, children } = props;

    return (
        <Card {...cardProps}>
            {!!header && <Card.Header {...headerProps}>{header}</Card.Header>}
            <Card.Body>{children}</Card.Body>
        </Card>
    );
};

export default SimpleCard;
